/**
 * 站点配色主题：写 html[data-theme]，持久化到 localStorage，全站页面共用。
 * 变量定义在 assets/css/theme.css；public/index.html 里有一段内联脚本在首屏前先读一次，避免闪色。
 */
export const THEME_STORAGE_KEY = "site-theme";
export const MODE_STORAGE_KEY = "site-mode";

export const THEMES = [
  { key: "claude", name: "陶土橙", note: "Claude 原版", colors: ["#d97757", "#f5e5dd", "#f0eee6", "#faf9f5"] },
  { key: "pine", name: "松针绿", note: "壹圆", colors: ["#5a6f47", "#6d8856", "#a6c196", "#e6ddb5"] },
  { key: "grape", name: "葡夜紫", note: "伍圆", colors: ["#76558b", "#b886b1", "#dccbba", "#f3d9ed"] },
  { key: "ocean", name: "深潮蓝", note: "拾圆", colors: ["#35667a", "#7399b5", "#c3aec4", "#cde0e7"] },
  { key: "caramel", name: "焦糖棕", note: "贰拾圆", colors: ["#7a5a3a", "#d2aa7a", "#f2c7cf", "#e9d8c6"] },
  { key: "cedar", name: "湖杉绿", note: "伍拾圆", colors: ["#4d8a6f", "#a8d5b7", "#c9eedf", "#eadbf6"] },
  { key: "berry", name: "浆果红", note: "壹佰圆", colors: ["#d71a44", "#db5f51", "#f99a9f", "#ded9b2"] },
  { key: "paper", name: "宣纸橘", note: "纸本暖阳", colors: ["#e07b39", "#f0a35e", "#f5c58f", "#efe6d5"] }
];

const DEFAULT_THEME = THEMES[0].key;

function isValid(key) {
  return THEMES.some(t => t.key === key);
}

export function getTheme() {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    if (isValid(saved)) return saved;
  } catch (e) {
    // 隐私模式等场景 localStorage 不可用，退回默认
  }
  return DEFAULT_THEME;
}

export function applyTheme(key) {
  const theme = isValid(key) ? key : DEFAULT_THEME;
  const root = document.documentElement;
  if (theme === DEFAULT_THEME) {
    root.removeAttribute("data-theme");
  } else {
    root.setAttribute("data-theme", theme);
  }
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch (e) {
    // 存不了就只在当前页生效
  }
  return theme;
}

export const MODES = ["light", "dark"];

export function getMode() {
  try {
    const saved = localStorage.getItem(MODE_STORAGE_KEY);
    if (MODES.indexOf(saved) !== -1) return saved;
  } catch (e) {
    // 同上
  }
  return "light";
}

export function applyMode(mode) {
  const m = MODES.indexOf(mode) !== -1 ? mode : "light";
  const root = document.documentElement;
  if (m === "dark") {
    root.setAttribute("data-mode", "dark");
  } else {
    root.removeAttribute("data-mode");
  }
  try {
    localStorage.setItem(MODE_STORAGE_KEY, m);
  } catch (e) {
    // 存不了就只在当前页生效
  }
  return m;
}

export function toggleMode() {
  return applyMode(getMode() === "dark" ? "light" : "dark");
}

export function initTheme() {
  // index.html 首屏脚本给 html 内联写过 --bg 防闪色，样式表已到位，这里清掉，否则会压住主题变量
  document.documentElement.style.removeProperty("--bg");
  document.documentElement.style.removeProperty("--ink");
  applyMode(getMode());
  return applyTheme(getTheme());
}
